import { render } from "./AddSalaryPayment.vue?vue&type=template&id=0b273204"
import script from "./AddSalaryPayment.vue?vue&type=script&lang=js"
export * from "./AddSalaryPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__